import React, { useEffect, useState } from "react";
import { Star, MessageSquareQuote } from "lucide-react";
import { api } from "../lib/constants";
import { Reveal } from "../components/Reveal";
import { Overline, SectionTitle, GoldButton } from "../components/site/Primitives";
import SEO from "../components/SEO";

export default function Depoimentos() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/testimonials").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  return (
    <div>
      <SEO title="Depoimentos | Barbearia das Estrelas e Prime Capilar Clinic" description="Depoimentos de clientes da Barbearia das Estrelas e da Prime Capilar Clinic." />

      <section className="border-b border-white/10 py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <Reveal><Overline className="mb-3">Depoimentos</Overline></Reveal>
          <Reveal delay={0.05}><SectionTitle>Quem faz, conta a experiência</SectionTitle></Reveal>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-24">
        {items.length === 0 ? (
          <Reveal>
            <div className="border border-white/12 rounded-sm bg-[#0b0b0b] p-10 lg:p-16 text-center max-w-2xl mx-auto">
              <MessageSquareQuote className="w-10 h-10 text-gold mx-auto" />
              <h3 className="font-heading font-600 uppercase text-white text-xl mt-5">Em breve, histórias reais</h3>
              <p className="text-zinc-400 mt-3 leading-relaxed">
                Os depoimentos dos nossos clientes serão publicados aqui. Quer ser um deles? Agende seu atendimento e viva a experiência.
              </p>
              <div className="mt-7 flex justify-center">
                <GoldButton to="/contato" data-testid="depoimentos-cta">QUERO FAZER PARTE</GoldButton>
              </div>
            </div>
          </Reveal>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {items.map((t, i) => (
              <Reveal key={t.id} delay={(i % 3) * 0.06}>
                <div className="border border-white/12 rounded-sm bg-[#0d0d0d] p-6 h-full flex flex-col">
                  <div className="flex gap-1 text-gold">
                    {Array.from({ length: t.rating || 5 }).map((_, k) => <Star key={k} className="w-4 h-4 fill-gold" />)}
                  </div>
                  <p className="text-zinc-200 leading-relaxed mt-4 flex-1">"{t.text}"</p>
                  <div className="flex items-center gap-3 mt-6 pt-5 border-t border-white/8">
                    {t.photo && <img src={t.photo} alt={t.name} className="w-10 h-10 rounded-full object-cover" />}
                    <div>
                      <p className="font-heading font-600 text-white text-sm">{t.name}</p>
                      <p className="text-xs text-zinc-500">{t.city}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
